<template>
    <b-tabs pills>
        <b-tab title="Kế hoạch bài dạy đang giao" @click="handleOnChangeTab(LessonPlaningDelivered)" :active="tabActive == LessonPlaningDelivered">
            <TabLessonPlaningAssign v-if="tabActive == LessonPlaningDelivered" />
        </b-tab>
        <b-tab title="Kho kế hoạch bài dạy" @click="handleOnChangeTab(LessonPlaningWarehouse)" :active="tabActive == LessonPlaningWarehouse">
            <TabLessonPlaningWarehouse v-if="tabActive == LessonPlaningWarehouse" />
        </b-tab>
    </b-tabs>
</template>
<script>
import TabLessonPlaningWarehouse from './../lesson_component/TabLessonPlaningWarehouse'
import TabLessonPlaningAssign from './../lesson_component/TabLessonPlaningAssign'
export default{
    name: "LessonPlanning",
    components:{
        TabLessonPlaningWarehouse,
        TabLessonPlaningAssign
    },
    data() {
        return {
            tabActive: 1,
            LessonPlaningDelivered: 1,
            LessonPlaningWarehouse: 2
            
        }
    },
    mounted(){
        if(this.$route.query.tabChild){
            this.tabActive = this.$route.query.tabChild
        }
    },
    methods:{
        handleOnChangeTab(tab){
            this.tabActive = tab
        }
    }
}
</script>